module.exports = __webpack_public_path__ + "static/media/permissaoCameraMobile.05b72385.jpg";